function Weather() {
    return (
        <>
            Weather
        </>
    );
}
  
export default Weather;